import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  involuntaryReasons,
  seperationTypes,
  voluntaryReasons,
} from "../../constants/seperation";
import { approveTaskRequestChange } from "../../store/TaskboxSlice/thunk";
import {
  getNoticePeriod,
  uploadFileWithPresignedUrl,
} from "../../store/SeperationSlice/thunk";
import { seperationActions } from "../../store/SeperationSlice";
import BackIcon from "../../assets/icons/arrow_back.svg";
import SubmitIcon from "../../assets/icons/inventory.svg";
import GroupIcon from "../../assets/icons/groups.svg";
import CheckIcon from "../../assets/icons/check.svg";
import CheckIconGrey from "../../assets/icons/check-grey.svg";
import CheckWhiteIcon from "../../assets/icons/check-white.svg";
import CloseIconGrey from "../../assets/icons/close_grey.svg";
import CloseIconWhtie from "../../assets/icons/close_white.svg";
import CustomDropdown from "../../commonComponents/CustomDropdown";
import CustomDatePicker from "../../commonComponents/CustomDatePicker";
import DoneAllWhiteIcon from "../../assets/icons/done_all_white.svg";
import MaybeIcon from "../../assets/icons/rule.svg";
import moment from "moment";
import CashImage from "../../assets/images/more-cash.png";
import InitialsCircle from "../InitialsCircle";
import Close from "../../assets/icons/close.svg";
import AttachmentIcon from "../../assets/icons/attach_email.svg";
import ValidIcon from "../../assets/icons/emergency_home_white.svg";
import "./SeperationApproval.css";

const SeperationApproval = () => {
  const [confirmation, setConfirmation] = useState(false);
  const [approverRemarks, setApproverRemarks] = useState("");

  const [isError, setIsError] = useState(false);
  const [confirmError, setConfirmError] = useState(false);

  const [payrollClearanceData, setPayrollClearanceData] = useState(null);

  const [separationQuestions, setSeparationQuestions] = useState({
    lastWorkingDay: "",
    separationReason: "",
    separationType: "",
    finalRecoveryDays: 0,
    futureRehire: null,
    approverRemarks: "",
    separationReasonComments: "",
    attachments: "",
    file: "",
  });

  const [itQuestions, setItQuestions] = useState({
    laptopRecovered: "",
    otherRecovery: "",
    otherRecoveryComments: "",
    totalRecoveryAmount: "",
  });

  const [financeQuestions, setFinanceQuestions] = useState({
    imprestRecovery: "",
    imprestRecoveryAmount: "",
    travelAdvanceRecovery: "",
    travelAdvanceRecoveryAmount: "",
    otherRecovery: "",
    otherRecoveryComments: "",
  });

  const [adminQuestions, setAdminQuestions] = useState({
    accessCardRecovered: "",
    carInOycsScheme: "",
    oycsSchemeClosed: "",
    otherRecovery: "",
    otherRecoveryDetails: "",
    totalRecoveryAmount: "",
  });

  const [exitInterviewQuestions, setExitInterviewQuestions] = useState({
    satisfiedWithGrowth: "",
    supportByManagerDuringStint: "",
    recommendCompanyToOthers: "",
    nextEmployerName: "",
    incrementReceivedByNextEmployer: "",
  });

  const [fileMandatoryErr, setFileMandatoryErr] = useState(false);
  const [showValidationError, setShowValidationError] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const empData = useSelector((state) => state.taskbox.separationEmpData);
  const approveTaskRequestChangeResponse = useSelector(
    (state) => state.taskbox.approveTaskRequestChangeResponse,
  );
  const approveTaskRequestChangeResponseStatus = useSelector(
    (state) => state.taskbox.approveTaskRequestChangeResponseStatus,
  );
  const noticePeriod = useSelector(
    (state) => state.seperation.noticePeriodResponse?.data,
  );
  const fullName = useSelector(
    (state) => state.auth?.loginResponse?.display_name || "",
  );

  const fileUploadResponseStatus = useSelector(
    (state) => state.seperation.fileUploadResponseStatus || "",
  );
  const fileUploadResponse = useSelector(
    (state) => state.seperation.fileUploadResponse || "",
  );

  const fileRef = useRef();

  useEffect(() => {
    return () => {
      dispatch(seperationActions.setInitialState());
    };
  }, []);

  useEffect(() => {
    console.log("Employee Data:", empData);

    let data = {};

    if (empData?.request_type === "Payroll Clearance") {
      if (empData?.it_clearance !== "None") {
        data.it_clearance = JSON.parse(empData?.it_clearance);
      } else {
        data.it_clearance = {};
      }

      if (empData?.admin_clearance !== "None") {
        data.admin_clearance = JSON.parse(empData?.admin_clearance);
      } else {
        data.admin_clearance = {};
      }

      if (empData?.finance_clearance !== "None") {
        data.finance_clearance = JSON.parse(empData?.finance_clearance);
      } else {
        data.finance_clearance = {};
      }

      setPayrollClearanceData({
        it_clearance: data.it_clearance,
        admin_clearance: data.admin_clearance,
        finance_clearance: data.finance_clearance,
      });

      console.log("\n\nPayroll clearance task data : ", {
        it_clearance: data.it_clearance,
        admin_clearance: data.admin_clearance,
        finance_clearance: data.finance_clearance,
      });
    }
  }, [empData]);

  useEffect(() => {
    if (empData?.request_type === "Separation Approval") {
      dispatch(getNoticePeriod({ employee_id: empData?.employee_id }));
    }
    return () => {
      dispatch(seperationActions.resetNoticePeriodDetails());
    };
  }, [dispatch, empData]);

  useEffect(() => {
    if (approveTaskRequestChangeResponseStatus === "SUCCESS") {
      console.log(
        "\n\n\n\n\n\n Separation Approval approveTaskRequestChangeResponse : ",
        approveTaskRequestChangeResponse,
      );

      navigate("../taskbox");
    } else if (approveTaskRequestChangeResponseStatus === "ERROR") {
      console.log(
        "\n\napproveTaskRequestChangeResponse : ",
        approveTaskRequestChangeResponse,
      );
    }
  }, [approveTaskRequestChangeResponseStatus]);

  useEffect(() => {
    if (fileUploadResponseStatus === "SUCCESS") {
      console.log("inHere upload success");

      handleSeparationFields({
        ...separationQuestions,
        attachments: fileUploadResponse?.presignedUrlResponse?.fields?.key,
      });
    }
  }, [fileUploadResponseStatus]);

  const handleSeparationFields = (data, key = null) => {
    const obj = {
      lastWorkingDay: data.lastWorkingDay,
      separationReason: data.separationReason,
      separationType: data.separationType,
      finalRecoveryDays: data.finalRecoveryDays,
      futureRehire: data.futureRehire,
      approverRemarks: data.approverRemarks,
      separationReasonComments: data.separationReasonComments,
      attachments: data.attachments,
      file: data.file,
    };
    if (key === "separationType") {
      obj.separationReason = "";
    }

    if (key === "fileClear") {
      obj.file = "";
      obj.attachments = "";
    }
    if (key === "file") {
      dispatch(
        uploadFileWithPresignedUrl({
          employee_id: empData?.employee_id,
          file: data.file,
          key: "seperation",
        }),
      );
    }

    console.log("\n\n\n\n handleSeparationFields : ", obj);

    setSeparationQuestions((prev) => ({ ...prev, ...obj }));
  };

  const handleITFields = (data) => {
    const obj = {
      laptopRecovered: data.laptopRecovered,
      otherRecovery: data.otherRecovery,
      otherRecoveryComments: data.otherRecoveryComments,
      totalRecoveryAmount: data.totalRecoveryAmount,
    };

    setItQuestions((prev) => ({ ...prev, ...obj }));
  };

  const handleAdminFields = (data) => {
    const obj = {
      accessCardRecovered: data.accessCardRecovered,
      carInOycsScheme: data.carInOycsScheme,
      oycsSchemeClosed: data.oycsSchemeClosed,
      otherRecovery: data.otherRecovery,
      otherRecoveryDetails: data.otherRecoveryDetails,
      totalRecoveryAmount: data.totalRecoveryAmount,
    };
    setAdminQuestions((prev) => ({ ...prev, ...obj }));
  };

  const handleFinanceFields = (data) => {
    console.log("Finance Data:", data);

    const obj = {
      imprestRecovery: data.imprestRecovery,
      imprestRecoveryAmount: data.imprestRecoveryAmount,
      travelAdvanceRecovery: data.travelAdvanceRecovery,
      travelAdvanceRecoveryAmount: data.travelAdvanceRecoveryAmount,
      otherRecovery: data.otherRecovery,
      otherRecoveryComments: data.otherRecoveryComments,
    };
    setFinanceQuestions((prev) => ({ ...prev, ...obj }));
  };

  const handleExitInterviewFields = (data) => {
    const obj = {
      satisfiedWithGrowth: data.satisfiedWithGrowth,
      supportByManagerDuringStint: data.supportByManagerDuringStint,
      recommendCompanyToOthers: data.recommendCompanyToOthers,
      nextEmployerName: data.nextEmployerName,
      incrementReceivedByNextEmployer: data.incrementReceivedByNextEmployer,
    };
    setExitInterviewQuestions((prev) => ({ ...prev, ...obj }));
  };

  const validateSeparationFields = () => {
    setFileMandatoryErr(false);
    setShowValidationError(false);
    console.log("Separation Questions:", separationQuestions);
    if (
      !separationQuestions.lastWorkingDay ||
      !separationQuestions.separationType ||
      !separationQuestions.separationReason ||
      separationQuestions.finalRecoveryDays == null ||
      separationQuestions.futureRehire === null
    ) {
      setIsError(true);
      return true;
    }

    // Check if attachment is provided when recovery_days > 0
    if (
      !separationQuestions.attachments &&
      Math.max(
        moment(
          moment(empData?.date_of_resignation).add(noticePeriod, "days"),
        ).diff(separationQuestions?.lastWorkingDay, "days"),
        0,
      ) > 0
    ) {
      setFileMandatoryErr(true);
      setShowValidationError(true);
      return true;
    }
  };

  const validateITFields = () => {
    if (
      itQuestions.laptopRecovered === "" ||
      itQuestions.otherRecovery === "" ||
      itQuestions.otherRecoveryComments === "" ||
      itQuestions.totalRecoveryAmount === "" ||
      !itQuestions.totalRecoveryAmount.match(/^[0-9]+$/)
    ) {
      console.log("Validation errors found");

      setIsError(true);
      return true;
    }
  };

  const validateFinanceFields = () => {
    if (
      financeQuestions.imprestRecovery === "" ||
      (financeQuestions.imprestRecovery === "Yes" &&
        !financeQuestions.imprestRecoveryAmount) ||
      isNaN(financeQuestions.imprestRecoveryAmount) ||
      financeQuestions.travelAdvanceRecovery === "" ||
      (financeQuestions.travelAdvanceRecovery === "Yes" &&
        !financeQuestions.travelAdvanceRecoveryAmount) ||
      isNaN(financeQuestions.travelAdvanceRecoveryAmount) ||
      financeQuestions.otherRecovery === "" ||
      (financeQuestions.otherRecovery === "Yes" &&
        !financeQuestions.otherRecoveryComments) ||
      !financeQuestions.imprestRecoveryAmount.match(/^[0-9]+$/) ||
      !financeQuestions.travelAdvanceRecoveryAmount.match(/^[0-9]+$/)
    ) {
      setIsError(true);
      return true;
    }
  };

  const validateAdminFields = () => {
    if (
      !adminQuestions.accessCardRecovered ||
      !adminQuestions.carInOycsScheme ||
      !adminQuestions.oycsSchemeClosed ||
      !adminQuestions.otherRecovery ||
      !adminQuestions.otherRecoveryDetails ||
      !adminQuestions.totalRecoveryAmount ||
      !adminQuestions.totalRecoveryAmount.match(/^[0-9]+$/)
    ) {
      setIsError(true);
      return true;
    }
  };

  const approveButtonHandler = (type) => {
    if (type === "approve") {
      let validationError = null;

      if (empData?.request_type === "Separation Approval") {
        validationError = validateSeparationFields();

        if (!confirmation) {
          setConfirmError(true);
          return;
        }
      } else if (empData?.request_type === "IT Clearance") {
        validationError = validateITFields();
      } else if (empData?.request_type === "Finance Clearance") {
        validationError = validateFinanceFields();
      } else if (empData?.request_type === "Admin Clearance") {
        validationError = validateAdminFields();
      }

      if (validationError === true) {
        console.log("Validation failed, cannot proceed");
        return;
      }

      console.log("\nRequest Approved");

      const payload = {
        approve_status: "Approved",
        id: empData?.id,
        employee_id: empData?.employee_id,
        request_type: empData?.request_type,
        approver_remarks: approverRemarks,
        status: "Approved",
        employee_type: empData?.employee_type,
        req_by_emp: empData?.req_by_emp,
        initiatore_emp_id: empData?.initiatore_emp_id,
      };

      switch (empData?.request_type) {
        case "Separation Approval": {
          console.log(
            "Separation Questions to be submitted:",
            separationQuestions,
          );
          payload.recovery_days = separationQuestions.finalRecoveryDays;
          payload.final_sepration_type = separationQuestions.separationType;
          payload.final_date_of_exit = separationQuestions.lastWorkingDay;
          payload.reason = separationQuestions.separationReason;
          payload.reason_comments =
            separationQuestions.separationReasonComments;
          payload.future_rehire = separationQuestions.futureRehire;
          payload.date_of_resignation = empData?.date_of_resignation;
          if (
            Math.max(
              moment(
                moment(empData?.date_of_resignation).add(noticePeriod, "days"),
              ).diff(separationQuestions?.lastWorkingDay, "days"),
              0,
            ) > 0
          ) {
            payload.attachments = separationQuestions.attachments;
          }

          break;
        }
        case "IT Clearance": {
          console.log("IT Questions to be submitted:", itQuestions);
          let data = {
            laptop_recovered: itQuestions.laptopRecovered,
            other_recovery: itQuestions.otherRecovery,
            other_recovery_comments: itQuestions.otherRecoveryComments,
            total_recovery_amount: itQuestions.totalRecoveryAmount,
            approved_date: moment(new Date()).format("YYYY-MM-DD"),
          };
          payload.total_recovery_amount = itQuestions.totalRecoveryAmount;
          payload.it_clearance = JSON.stringify(data);
          break;
        }
        case "Finance Clearance": {
          console.log("Finance Questions to be submitted:", financeQuestions);
          let data = {
            other_recovery: financeQuestions.otherRecovery,
            other_recovery_comments: financeQuestions.otherRecoveryComments,
            imprest_recovery: financeQuestions.imprestRecovery,
            imprest_recovery_amount: financeQuestions.imprestRecoveryAmount,
            travel_advance_recovery: financeQuestions.travelAdvanceRecovery,
            travel_advance_recovery_amount:
              financeQuestions.travelAdvanceRecoveryAmount,
            approved_date: moment(new Date()).format("YYYY-MM-DD"),
          };
          payload.total_recovery_amount =
            (financeQuestions.imprestRecoveryAmount
              ? parseInt(financeQuestions.imprestRecoveryAmount)
              : 0) +
            (financeQuestions.travelAdvanceRecoveryAmount
              ? parseInt(financeQuestions.travelAdvanceRecoveryAmount)
              : 0) +
            (financeQuestions.otherRecovery === "Yes"
              ? parseInt(financeQuestions.otherRecoveryComments)
              : 0);

          payload.finance_clearance = JSON.stringify(data);
          break;
        }
        case "Admin Clearance": {
          console.log("Admin Questions to be submitted:", adminQuestions);
          let data = {
            access_card_recovered: adminQuestions.accessCardRecovered,
            car_in_oycs_scheme: adminQuestions.carInOycsScheme,
            oycs_scheme_closed: adminQuestions.oycsSchemeClosed,
            other_recovery: adminQuestions.otherRecovery,
            other_recovery_comments: adminQuestions.otherRecoveryComments,
            total_recovery_amount: adminQuestions.totalRecoveryAmount,
            approved_date: moment(new Date()).format("YYYY-MM-DD"),
          };
          payload.total_recovery_amount = adminQuestions.totalRecoveryAmount;
          payload.admin_clearance = JSON.stringify(data);
          break;
        }

        case "Exit Interview Form": {
          console.log(
            "Exit Interview Questions to be submitted:",
            exitInterviewQuestions,
          );
          let data = {
            satisfied_with_growth: exitInterviewQuestions.satisfiedWithGrowth,
            support_by_manager_during_stint:
              exitInterviewQuestions.supportByManagerDuringStint,
            recommend_company_to_others:
              exitInterviewQuestions.recommendCompanyToOthers,
            next_employer_name: exitInterviewQuestions.nextEmployerName,
            increment_received_by_next_employer:
              exitInterviewQuestions.incrementReceivedByNextEmployer,
            approved_date: moment(new Date()).format("YYYY-MM-DD"),
          };
          payload.exit_interview = JSON.stringify(data);
          break;
        }
        default:
          {
            console.log("Unknown request type");
          }
          break;
      }

      console.log(
        "Payload to for",
        empData?.request_type,
        " approval :\n\n",
        JSON.stringify(payload, null, 3),
      );

      dispatch(approveTaskRequestChange(payload));

      return;
    } else if (type === "reject") {
      const payload = {
        approve_status: "Rejected",
        status: "Rejected",
        request_type: empData?.request_type,
        id: empData?.id,
        employee_id: empData?.employee_id,
        approverRemarks: approverRemarks,
      };
      console.log("Request Rejected", payload);

      dispatch(approveTaskRequestChange(payload));
      return;
    }
  };

  const ValidationErrorPopUp = () => {
    useEffect(() => {
      const timer = setTimeout(() => {
        setShowValidationError(false);
      }, 5000);

      return () => clearTimeout(timer);
    }, []);
    return (
      <div className="flex rcv-popup">
        <img src={ValidIcon} alt="err-ic" />
        <div className="rcv-popup-text">
          You have made changes to recovery days, kindly ensure the required
          employee’s L2 manager approval is attached. Incorrect approval
          document will be treated as violation of code of conduct
        </div>
      </div>
    );
  };

  return (
    <div className="sp-home">
      <div className="flex justify-between w-full">
        <div className="flex items-center">
          <img
            src={BackIcon}
            alt="icon"
            className="rq-home-btn-ico mr-2 cursor-pointer"
            onClick={() => navigate("../taskbox")}
          />

          <div className="sp-head">{(empData?.request_type).toLowerCase()}</div>
        </div>
        <div className="flex">
          {empData?.request_type === "Separation Approval" && (
            <button
              className="btn p-btn p-btn-blk p-btn-red ml-2"
              onClick={() => approveButtonHandler("reject")}
            >
              <img className="p-btn-icon" src={CloseIconWhtie} alt="" />
              <div className="p-btn-text">Reject</div>
            </button>
          )}
          <div className="position-relative">
            <button
              className={`btn p-btn ${
                empData?.request_type === "Separation Approval"
                  ? "p-btn-green"
                  : "p-btn-og"
              }`}
              onClick={() => approveButtonHandler("approve")}
            >
              <img
                className="p-btn-icon"
                src={
                  empData?.request_type === "Separation Approval"
                    ? DoneAllWhiteIcon
                    : SubmitIcon
                }
                alt=""
              />
              <div className="p-btn-text">
                {empData?.request_type === "Separation Approval"
                  ? "Approve"
                  : "Submit"}
              </div>
            </button>
            {showValidationError && <ValidationErrorPopUp />}
          </div>
        </div>
      </div>
      {empData?.request_type !== "Exit Interview Form" && (
        <div className="sp-emp-card w-full">
          <div className="sp-right-box">
            <div className="sp-emp-empid">
              Employee ID #{empData?.employee_id}
            </div>
            <div className="flex items-center">
              <InitialsCircle fullName={empData?.full_name} size={24} />
              <div className="sp-emp-name">{empData?.full_name}</div>
              <div
                className="flex sp-com"
                style={{
                  backgroundColor: "purple",
                }}
              >
                <img className="sp-desgn-img" src={GroupIcon} alt="emp-icon" />
                <div className="sp-emp-desgn">{empData?.designation}</div>
              </div>
            </div>
          </div>

          {empData?.request_type !== "Separation Approval" && (
            <div className="total-amt-container">
              <div className="total-amt-label">total recovery amount</div>

              <div className="total-amt-box">
                <img
                  style={{
                    height: "20px",
                    width: "20px",
                    position: "relative",
                    objectFit: "cover",
                  }}
                  src={CashImage}
                  alt="CashImage"
                />
                <div className="total-amt-value">
                  {empData?.total_recovery_amount
                    ? `₹ ${empData?.total_recovery_amount}`
                    : "₹ 0"}{" "}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {empData?.request_type === "Separation Approval" && (
        <div className="flex flex-col gap-3 mt-3">
          <div className="sp-subhead">summary</div>
          <div className="sp-sm">
            <div className="flex flex-wrap sp-sm-box">
              <div className="flex flex-col sp-emp-subbox">
                <div className="sp-sm-label">Date of Resignation</div>
                <div className="sp-sm-value">
                  {empData?.date_of_resignation}
                </div>
              </div>
              <div className="flex flex-col sp-emp-subbox">
                <div className="sp-sm-label">Requested Last Working Day</div>
                <div className="sp-sm-value">{empData?.req_date_of_exit}</div>
              </div>
              <div className="flex flex-col sp-emp-subbox">
                <div className="sp-sm-label">Recovery Days</div>
                <div className="sp-sm-value">
                  {empData?.recovery_days + " Days"}{" "}
                </div>
              </div>
              <div className="flex flex-col sp-emp-subbox1">
                <div className="sp-sm-label">Separation Reason</div>
                <div className="sp-sm-value">{empData?.reason}</div>
              </div>

              <div className="profile-detail-box">
                <div className="profile-detail-label">Region</div>
                <div className="profile-detail-value">
                  {empData?.region || "NA"}
                </div>
              </div>

              <div className="profile-detail-box"></div>
            </div>
          </div>

          <div className="sp-border-bottom w-full"></div>

          <div className="flex w-full">
            <div className="flex flex-col mb-0">
              <CustomDatePicker
                isRequired={true}
                showOptional={true}
                isError={isError}
                label={"Agreed Last Working Day"}
                value={separationQuestions.lastWorkingDay}
                allowFutureDate={true}
                onChange={(value) => {
                  handleSeparationFields({
                    ...separationQuestions,
                    lastWorkingDay: value
                      ? moment(value).format("YYYY-MM-DD")
                      : "",
                    finalRecoveryDays:
                      value !== "" && empData?.date_of_resignation
                        ? Math.max(
                            moment(
                              moment(empData?.date_of_resignation).add(
                                noticePeriod,
                                "days",
                              ),
                            ).diff(value, "days"),
                            0,
                          )
                        : 0,
                  });
                }}
                placeholderText={"Select a date"}
                allowPastDate={false}
                minAllowedDate={moment(empData?.date_of_resignation)}
              />
            </div>
            <div className="flex flex-col form-detail mb-0">
              <div className="emp-form-label">Final Recovery Days*</div>
              <input
                className="emp-form-input"
                // readOnly
                type="number"
                min="0"
                onChange={(e) => {
                  let value = e.target.value;
                  if (value === "") {
                    handleSeparationFields({
                      ...separationQuestions,
                      finalRecoveryDays: "",
                    });
                    return;
                  }
                  if (Number(value) < 0) return;
                  value = String(Number(value));
                  handleSeparationFields({
                    ...separationQuestions,
                    finalRecoveryDays: value,
                  });
                }}
                value={separationQuestions?.finalRecoveryDays}
                style={{
                  border:
                    !separationQuestions.finalRecoveryDays && isError
                      ? "1px solid red"
                      : "",
                }}
              />
            </div>
            <div className="flex flex-col form-detail justify-content-space-between mb-0 w-full">
              <div className="flex emp-form-label"></div>
              <input
                className="emp-form-input-special"
                // style={{ border: isError && !separationReasonComments ? '1px solid red' : '1px solid #C4C4C4' }}
                placeholder="Describe your reason for separation here..."
                onChange={(e) => {
                  handleSeparationFields({
                    ...separationQuestions,
                    separationReasonComments: e.target.value,
                  });
                }}
              />
            </div>
          </div>

          <div className="sp-border-bottom w-full"></div>

          <div className="flex w-full">
            <div className="flex flex-col mb-0">
              <CustomDropdown
                showOptional={true}
                label={"Final Separation Type"}
                isError={isError}
                className="emp-form-input"
                options={seperationTypes}
                value={separationQuestions.separationType}
                onSelectOption={(value) => {
                  handleSeparationFields(
                    {
                      ...separationQuestions,
                      separationType: value,
                    },
                    "separationType",
                  );
                }}
                isRequired={true}
                isObjectDrop={false}
              />
            </div>
            <div className="flex flex-col mb-0">
              <CustomDropdown
                showOptional={true}
                label={"Separation Reason"}
                isError={isError}
                className="emp-form-input"
                options={
                  separationQuestions.separationType === "Voluntary"
                    ? voluntaryReasons
                    : separationQuestions.separationType === "Involuntary"
                      ? involuntaryReasons
                      : separationQuestions.separationType === "Death"
                        ? ["Death"]
                        : separationQuestions.separationType === "Retirement"
                          ? ["Retirement"]
                          : []
                }
                value={separationQuestions.separationReason}
                onSelectOption={(value) => {
                  handleSeparationFields({
                    ...separationQuestions,
                    separationReason: value,
                  });
                }}
                isRequired={true}
                isObjectDrop={false}
              />
            </div>
            <div
              className={`flex flex-row question-box-common items-center rehire-box mb-0 ${
                !separationQuestions.futureRehire && isError && "error-border"
              }`}
            >
              <div className="work-label">Rehire in Future?*</div>
              <div className="flex">
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      separationQuestions.futureRehire === "Yes"
                        ? "2px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleSeparationFields({
                      ...separationQuestions,
                      futureRehire: "Yes",
                    });
                  }}
                >
                  <img
                    className="work-icon"
                    src={CheckIconGrey}
                    alt="work-icon"
                  />
                  <div className="work-check-label">Yes</div>
                </div>
                <div
                  className="flex items-center work-check-box"
                  onClick={() => {
                    handleSeparationFields({
                      ...separationQuestions,
                      futureRehire: "No",
                    });
                  }}
                  style={{
                    border:
                      separationQuestions.futureRehire === "No"
                        ? "1px solid #172128"
                        : "none",
                  }}
                >
                  <img
                    className="work-icon"
                    src={CloseIconGrey}
                    alt="work-icon"
                  />
                  <div className="work-check-label">No</div>
                </div>
              </div>
            </div>
          </div>

          <div className="sp-border-bottom w-full"></div>

          <div className={`confirmation-container`}>
            <div className="sp-subhead">confirmation</div>
            <div className="flex flex flex-direction-row items-center gap-2">
              <div
                className="check-box"
                onClick={() => {
                  confirmError && setConfirmError(false);
                  setConfirmation(!confirmation);
                }}
              >
                {confirmation && (
                  <img
                    className="check-icon"
                    src={CheckWhiteIcon}
                    alt="work-icon"
                  />
                )}
              </div>
              <div
                className={`confirmation-textbox ${
                  confirmError ? "error-border" : ""
                }`}
              >
                <div className="confirm-text">
                  I confirm that all updated details have been thoroughly
                  discussed with the employee.
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {empData?.request_type === "IT Clearance" && (
        <div className="flex flex-col">
          <div
            className={`flex flex-col question-box-common items-center w-fit-content align-items-flex-start gap-3 ${
              itQuestions.laptopRecovered === "" && isError && "error-border"
            }`}
          >
            <div className="work-label">
              Has the Laptop / Desktop along with all accessories been
              recovered?*
            </div>
            <div className="flex w-full align-items-flex-start">
              <div
                className="flex items-center work-check-box"
                style={{
                  border:
                    itQuestions.laptopRecovered === "Yes"
                      ? "1px solid #172128"
                      : "none",
                }}
                onClick={() => {
                  handleITFields({ ...itQuestions, laptopRecovered: "Yes" });
                }}
              >
                <img className="work-icon" src={CheckIcon} alt="work-icon" />
                <div className="work-check-label">Yes</div>
              </div>
              <div
                className="flex items-center work-check-box"
                style={{
                  border:
                    itQuestions.laptopRecovered === "No"
                      ? "1px solid #172128"
                      : "none",
                }}
                onClick={() => {
                  handleITFields({ ...itQuestions, laptopRecovered: "No" });
                }}
              >
                <img
                  className="work-icon"
                  src={CloseIconGrey}
                  alt="work-icon"
                />
                <div className="work-check-label">No</div>
              </div>
              <div
                className="flex items-center work-check-box"
                style={{
                  border:
                    itQuestions.laptopRecovered === "Not Applicable"
                      ? "1px solid #172128"
                      : "none",
                }}
                onClick={() => {
                  handleITFields({
                    ...itQuestions,
                    laptopRecovered: "Not Applicable",
                  });
                }}
              >
                <img
                  className="work-icon"
                  src={CloseIconGrey}
                  alt="work-icon"
                />
                <div className="work-check-label">Not Applicable</div>
              </div>
            </div>
          </div>
          <div
            className={`flex flex-col question-box-common items-start gap-3 ${
              itQuestions.otherRecovery === "" && isError && "error-border"
            }`}
          >
            <div className="work-label">Any Other Recovery?*</div>
            <div className="flex w-full align-items-flex-start">
              <div
                className="flex items-center work-check-box"
                style={{
                  border:
                    itQuestions.otherRecovery === "Yes"
                      ? "1px solid #172128"
                      : "none",
                }}
                onClick={() => {
                  handleITFields({ ...itQuestions, otherRecovery: "Yes" });
                }}
              >
                <img className="work-icon" src={CheckIcon} alt="work-icon" />
                <div className="work-check-label">Yes</div>
              </div>
              <div
                className="flex items-center work-check-box"
                style={{
                  border:
                    itQuestions.otherRecovery === "No"
                      ? "1px solid #172128"
                      : "none",
                }}
                onClick={() => {
                  handleITFields({ ...itQuestions, otherRecovery: "No" });
                }}
              >
                <img
                  className="work-icon"
                  src={CloseIconGrey}
                  alt="work-icon"
                />
                <div className="work-check-label">No</div>
              </div>
            </div>
            <div className="separator-line"></div>
            <input
              className={`emp-form-input-special ${
                itQuestions.otherRecoveryComments === "" &&
                isError &&
                "error-border"
              }`}
              placeholder="Please mention details of other recovery*"
              onChange={(e) => {
                handleITFields({
                  ...itQuestions,
                  otherRecoveryComments: e.target.value,
                });
              }}
            />
          </div>
          <div className="flex flex-col form-detail">
            <div className="emp-form-label">Total Recovery Amount*</div>
            <input
              className={`emp-form-input ${
                (itQuestions.totalRecoveryAmount === "" ||
                  !itQuestions.totalRecoveryAmount.match(
                    /^[0-9]*\.?[0-9]*$/,
                  )) &&
                isError &&
                "error-border"
              }`}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9.]/g, "");
                handleITFields({
                  ...itQuestions,
                  totalRecoveryAmount: value,
                });
              }}
              value={itQuestions.totalRecoveryAmount}
            />
          </div>
        </div>
      )}

      {empData?.request_type === "Finance Clearance" && (
        <div className="flex align-items-flex-start">
          <div
            className={`flex-col question-box-common items-center w-fit-content mr-3 ${
              financeQuestions.imprestRecovery === "" &&
              isError &&
              "error-border"
            }`}
          >
            <div className="work-label">
              Is there any recovery on amount of Imprest?*
            </div>
            <div className="flex">
              <div
                className="flex items-center work-check-box"
                style={{
                  border:
                    financeQuestions.imprestRecovery === "Yes"
                      ? "1px solid #172128"
                      : "none",
                }}
                onClick={() => {
                  handleFinanceFields({
                    ...financeQuestions,
                    imprestRecovery: "Yes",
                  });
                }}
              >
                <img className="work-icon" src={CheckIcon} alt="work-icon" />
                <div className="work-check-label">Yes</div>
              </div>
              <div
                className="flex items-center work-check-box"
                style={{
                  border:
                    financeQuestions.imprestRecovery === "No"
                      ? "1px solid #172128"
                      : "none",
                }}
                onClick={() => {
                  handleFinanceFields({
                    ...financeQuestions,
                    imprestRecovery: "No",
                  });
                }}
              >
                <img
                  className="work-icon"
                  src={CloseIconGrey}
                  alt="work-icon"
                />
                <div className="work-check-label">No</div>
              </div>
            </div>

            <div
              className="solid-separator"
              style={{
                marginTop: "12px",
                width: "100%",
                height: "1px",
                background: "#F1F6FA",
              }}
            ></div>

            <div className="flex-col form-detail mt-3">
              <div className="emp-form-label">Imprest Recovery Amount*</div>
              <input
                className="emp-form-input"
                style={{
                  width: "360px",
                  border:
                    (financeQuestions.imprestRecoveryAmount === "" ||
                      !financeQuestions.imprestRecoveryAmount.match(
                        /^[0-9]*\.?[0-9]*$/,
                      )) &&
                    isError
                      ? "1px solid red"
                      : "none",
                }}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9.]/g, "");
                  handleFinanceFields({
                    ...financeQuestions,
                    imprestRecoveryAmount: value,
                  });
                }}
                value={financeQuestions.imprestRecoveryAmount}
              />
            </div>
          </div>
          <div
            className={`flex-col question-box-common items-center w-fit-content mr-3 ${
              financeQuestions.travelAdvanceRecovery === "" &&
              isError &&
              "error-border"
            }`}
          >
            <div className="work-label">
              Is there any recovery on account of Travel Advance?*
            </div>
            <div className="flex">
              <div
                className="flex items-center work-check-box"
                style={{
                  border:
                    financeQuestions.travelAdvanceRecovery === "Yes"
                      ? "1px solid #172128"
                      : "none",
                }}
                onClick={() => {
                  handleFinanceFields({
                    ...financeQuestions,
                    travelAdvanceRecovery: "Yes",
                  });
                }}
              >
                <img className="work-icon" src={CheckIcon} alt="work-icon" />
                <div className="work-check-label">Yes</div>
              </div>
              <div
                className="flex items-center work-check-box"
                style={{
                  border:
                    financeQuestions.travelAdvanceRecovery === "No"
                      ? "1px solid #172128"
                      : "none",
                }}
                onClick={() => {
                  handleFinanceFields({
                    ...financeQuestions,
                    travelAdvanceRecovery: "No",
                  });
                }}
              >
                <img
                  className="work-icon"
                  src={CloseIconGrey}
                  alt="work-icon"
                />
                <div className="work-check-label">No</div>
              </div>
            </div>

            <div
              className="solid-separator"
              style={{
                marginTop: "12px",
                width: "100%",
                height: "1px",
                background: "#F1F6FA",
              }}
            ></div>

            <div className="flex flex-col form-detail mt-3">
              <div className="emp-form-label">
                Travel Advance Recovery Amount*
              </div>
              <div className="flex">
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      financeQuestions.imprestRecovery === "Yes"
                        ? "1px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleFinanceFields({
                      ...financeQuestions,
                      imprestRecovery: "Yes",
                    });
                  }}
                >
                  <img className="work-icon" src={CheckIcon} alt="work-icon" />
                  <div className="work-check-label">Yes</div>
                </div>
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      financeQuestions.imprestRecovery === "No"
                        ? "1px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleFinanceFields({
                      ...financeQuestions,
                      imprestRecovery: "No",
                    });
                  }}
                >
                  <img
                    className="work-icon"
                    src={CloseIconGrey}
                    alt="work-icon"
                  />
                  <div className="work-check-label">No</div>
                </div>
              </div>

              <div
                className="solid-separator"
                style={{
                  marginTop: "12px",
                  width: "100%",
                  height: "1px",
                  background: "#F1F6FA",
                }}
              ></div>

              <div className="flex-col form-detail mt-3">
                <div className="emp-form-label">Imprest Recovery Amount*</div>
                <input
                  className="emp-form-input"
                  style={{
                    width: "360px",
                    border:
                      (financeQuestions.imprestRecoveryAmount === "" ||
                        !financeQuestions.imprestRecoveryAmount.match(
                          /^[0-9]*\.?[0-9]*$/,
                        )) &&
                      isError
                        ? "1px solid red"
                        : "none",
                  }}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9.]/g, "");
                    handleFinanceFields({
                      ...financeQuestions,
                      imprestRecoveryAmount: value,
                    });
                  }}
                  value={financeQuestions.imprestRecoveryAmount}
                />
              </div>
            </div>
            <div
              className={`flex-col question-box-common items-center w-fit-content mr-3 ${
                financeQuestions.travelAdvanceRecovery === "" &&
                isError &&
                "error-border"
              }`}
            >
              <div className="work-label">
                Is there any recovery on account of Travel Advance?*
              </div>
              <div className="flex">
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      financeQuestions.travelAdvanceRecovery === "Yes"
                        ? "1px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleFinanceFields({
                      ...financeQuestions,
                      travelAdvanceRecovery: "Yes",
                    });
                  }}
                >
                  <img className="work-icon" src={CheckIcon} alt="work-icon" />
                  <div className="work-check-label">Yes</div>
                </div>
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      financeQuestions.travelAdvanceRecovery === "No"
                        ? "1px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleFinanceFields({
                      ...financeQuestions,
                      travelAdvanceRecovery: "No",
                    });
                  }}
                >
                  <img
                    className="work-icon"
                    src={CloseIconGrey}
                    alt="work-icon"
                  />
                  <div className="work-check-label">No</div>
                </div>
              </div>

              <div
                className="solid-separator"
                style={{
                  marginTop: "12px",
                  width: "100%",
                  height: "1px",
                  background: "#F1F6FA",
                }}
              ></div>

              <div className="flex flex-col form-detail mt-3">
                <div className="emp-form-label">
                  Travel Advance Recovery Amount*
                </div>
                <input
                  className="emp-form-input"
                  style={{
                    width: "360px",
                    border:
                      (financeQuestions.travelAdvanceRecoveryAmount === "" ||
                        !financeQuestions.travelAdvanceRecoveryAmount.match(
                          /^[0-9]*\.?[0-9]*$/,
                        )) &&
                      isError
                        ? "1px solid red"
                        : "none",
                  }}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9.]/g, "");
                    handleFinanceFields({
                      ...financeQuestions,
                      travelAdvanceRecoveryAmount: value,
                    });
                  }}
                  value={financeQuestions.travelAdvanceRecoveryAmount}
                />
              </div>
            </div>
            <div
              className={`flex-col question-box-common items-center w-fit-content mr-3 ${
                financeQuestions.otherRecovery === "" &&
                isError &&
                "error-border"
              }`}
            >
              <div className="work-label">Is there any other recovery?*</div>
              <div className="flex">
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      financeQuestions.otherRecovery === "Yes"
                        ? "1px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleFinanceFields({
                      ...financeQuestions,
                      otherRecovery: "Yes",
                    });
                  }}
                >
                  <img className="work-icon" src={CheckIcon} alt="work-icon" />
                  <div className="work-check-label">Yes</div>
                </div>
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      financeQuestions.otherRecovery === "No"
                        ? "1px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleFinanceFields({
                      ...financeQuestions,
                      otherRecovery: "No",
                    });
                  }}
                >
                  <img
                    className="work-icon"
                    src={CloseIconGrey}
                    alt="work-icon"
                  />
                  <div className="work-check-label">No</div>
                </div>
              </div>

              <div
                className="solid-separator"
                style={{
                  marginTop: "12px",
                  width: "100%",
                  height: "1px",
                  background: "#F1F6FA",
                }}
              ></div>

              <div className="flex flex-col form-detail mt-3">
                <input
                  className={`emp-form-input ${
                    financeQuestions.otherRecoveryComments === "" &&
                    isError &&
                    "error-border"
                  }`}
                  style={{
                    width: "360px",
                  }}
                  onChange={(e) => {
                    handleFinanceFields({
                      ...financeQuestions,
                      otherRecoveryComments: e.target.value,
                    });
                  }}
                  placeholder="Please mention details of other recovery*"
                />
              </div>
            </div>
          </div>
          <div
            className={`flex-col question-box-common items-center w-fit-content mr-3 ${
              financeQuestions.otherRecovery === "" && isError && "error-border"
            }`}
          >
            <div className="work-label">Is there any other recovery?*</div>
            <div className="flex">
              <div
                className="flex items-center work-check-box"
                style={{
                  border:
                    financeQuestions.otherRecovery === "Yes"
                      ? "1px solid #172128"
                      : "none",
                }}
                onClick={() => {
                  handleFinanceFields({
                    ...financeQuestions,
                    otherRecovery: "Yes",
                  });
                }}
              >
                <img className="work-icon" src={CheckIcon} alt="work-icon" />
                <div className="work-check-label">Yes</div>
              </div>
              <div
                className="flex items-center work-check-box"
                style={{
                  border:
                    financeQuestions.otherRecovery === "No"
                      ? "1px solid #172128"
                      : "none",
                }}
                onClick={() => {
                  handleFinanceFields({
                    ...financeQuestions,
                    otherRecovery: "No",
                  });
                }}
              >
                <img
                  className="work-icon"
                  src={CloseIconGrey}
                  alt="work-icon"
                />
                <div className="work-check-label">No</div>
              </div>
            </div>

            <div
              className="solid-separator"
              style={{
                marginTop: "12px",
                width: "100%",
                height: "1px",
                background: "#F1F6FA",
              }}
            ></div>

            <div className="flex flex-col form-detail mt-3">
              <input
                className={`emp-form-input ${
                  financeQuestions.otherRecoveryComments === "" &&
                  isError &&
                  "error-border"
                }`}
                style={{
                  width: "360px",
                }}
                onChange={(e) => {
                  handleFinanceFields({
                    ...financeQuestions,
                    otherRecoveryComments: e.target.value,
                  });
                }}
                placeholder="Please mention details of other recovery*"
              />
            </div>
          </div>
        </div>
      )}

      {empData?.request_type === "Admin Clearance" && (
        <>
          <div className="flex flex-row w-full gap-3">
            <div
              className={`flex flex-col question-box w-fit-content align-items-flex-start gap-3 ${
                adminQuestions.accessCardRecovered === "" &&
                isError &&
                "error-border"
              }`}
            >
              <div className="question-label">
                Has the Access / Identity Card been recovered / destroyed by the
                employee?*
              </div>
              <div className="flex w-full align-items-flex-start">
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      adminQuestions.accessCardRecovered === "Yes"
                        ? "1px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleAdminFields({
                      ...adminQuestions,
                      accessCardRecovered: "Yes",
                    });
                  }}
                >
                  <img className="work-icon" src={CheckIcon} alt="work-icon" />
                  <div className="work-check-label">Yes</div>
                </div>
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      adminQuestions.accessCardRecovered === "No"
                        ? "1px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleAdminFields({
                      ...adminQuestions,
                      accessCardRecovered: "No",
                    });
                  }}
                >
                  <img
                    className="work-icon"
                    src={CloseIconGrey}
                    alt="work-icon"
                  />
                  <div className="work-check-label">No</div>
                </div>
              </div>
            </div>
            <div
              className={`flex flex-col question-box w-fit-content align-items-flex-start gap-3 ${
                adminQuestions.carInOycsScheme === "" &&
                isError &&
                "error-border"
              }`}
            >
              <div className="question-label">
                Whether Employee has car under OYCS Scheme?*
              </div>
              <div className="flex w-full align-items-flex-start">
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      adminQuestions.carInOycsScheme === "Yes"
                        ? "1px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleAdminFields({
                      ...adminQuestions,
                      carInOycsScheme: "Yes",
                    });
                  }}
                >
                  <img className="work-icon" src={CheckIcon} alt="work-icon" />
                  <div className="work-check-label">Yes</div>
                </div>
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      adminQuestions.carInOycsScheme === "No"
                        ? "1px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleAdminFields({
                      ...adminQuestions,
                      carInOycsScheme: "No",
                    });
                  }}
                >
                  <img
                    className="work-icon"
                    src={CloseIconGrey}
                    alt="work-icon"
                  />
                  <div className="work-check-label">No</div>
                </div>
              </div>
            </div>
            <div
              className={`flex flex-col question-box w-fit-content align-items-flex-start gap-3 ${
                adminQuestions.oycsSchemeClosed === "" &&
                isError &&
                "error-border"
              }`}
            >
              <div className="question-label">
                Has the OYCS Scheme been closed by the employee?*
              </div>
              <div className="flex w-full align-items-flex-start">
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      adminQuestions.oycsSchemeClosed === "Yes"
                        ? "1px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleAdminFields({
                      ...adminQuestions,
                      oycsSchemeClosed: "Yes",
                    });
                  }}
                >
                  <img className="work-icon" src={CheckIcon} alt="work-icon" />
                  <div className="work-check-label">Yes</div>
                </div>
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      adminQuestions.oycsSchemeClosed === "No"
                        ? "1px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleAdminFields({
                      ...adminQuestions,
                      oycsSchemeClosed: "No",
                    });
                  }}
                >
                  <img
                    className="work-icon"
                    src={CloseIconGrey}
                    alt="work-icon"
                  />
                  <div className="work-check-label">No</div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="flex flex-col align-items-flex-start gap-3"
            style={{ width: "415px" }}
          >
            <div
              className={`flex w-full question-box flex-col align-items-flex-start gap-3 ${
                adminQuestions.otherRecovery === "" && isError && "error-border"
              }`}
            >
              <div className="flex  w-full question-label">
                Any Other Recovery?*
              </div>
              <div className="flex w-full align-items-flex-start">
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      adminQuestions.otherRecovery === "Yes"
                        ? "1px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleAdminFields({
                      ...adminQuestions,
                      otherRecovery: "Yes",
                    });
                  }}
                >
                  <img className="work-icon" src={CheckIcon} alt="work-icon" />
                  <div className="work-check-label">Yes</div>
                </div>
                <div
                  className="flex items-center work-check-box"
                  style={{
                    border:
                      adminQuestions.otherRecovery === "No"
                        ? "1px solid #172128"
                        : "none",
                  }}
                  onClick={() => {
                    handleAdminFields({
                      ...adminQuestions,
                      otherRecovery: "No",
                    });
                  }}
                >
                  <img
                    className="work-icon"
                    src={CloseIconGrey}
                    alt="work-icon"
                  />
                  <div className="work-check-label">No</div>
                </div>
              </div>

              <div
                className="solid-separator"
                style={{ width: "100%", height: "1px", background: "#F1F6FA" }}
              ></div>

              <div className="flex flex-col form-detail justify-content-space-between mb-0 w-full">
                <input
                  className="emp-form-input-special"
                  style={{
                    border:
                      isError && adminQuestions.otherRecoveryDetails === ""
                        ? "1px solid red"
                        : "",
                  }}
                  placeholder="Please mention details of other recovery*"
                  onChange={(e) => {
                    handleAdminFields({
                      ...adminQuestions,
                      otherRecoveryDetails: e.target.value,
                    });
                  }}
                />
              </div>
            </div>

            <div className="flex w-full flex-col form-detail mb-0">
              <div className="emp-form-label">Total Recovery Amount*</div>
              <input
                className="emp-form-input"
                style={{
                  border:
                    (!adminQuestions.totalRecoveryAmount === "" ||
                      !adminQuestions.totalRecoveryAmount.match(
                        /^[0-9]*\.?[0-9]*$/,
                      )) &&
                    isError
                      ? "1px solid red"
                      : "",
                }}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9.]/g, "");
                  handleAdminFields({
                    ...adminQuestions,
                    totalRecoveryAmount: value,
                  });
                }}
                value={adminQuestions.totalRecoveryAmount}
              />
            </div>
          </div>
        </>
      )}

      {empData?.request_type === "Payroll Clearance" && (
        <div className="flex flex-col">
          <div className="sp-subhead mb-2">IT Clearance summary</div>
          <div className="w-full">
            <div className="sp-sm">
              <div className="flex flex-wrap sp-sm-box">
                <div className="flex flex-col sp-emp-subbox">
                  <div className="sp-sm-label">
                    Has the Laptop / Desktop along with all accessories been
                    recovered?*
                  </div>
                  <div className="sp-sm-value">
                    {payrollClearanceData?.it_clearance?.laptop_recovered ||
                      "NA"}
                  </div>
                </div>
                <div className="flex flex-col sp-emp-subbox">
                  <div className="sp-sm-label">Any Other Recovery?*</div>
                  <div className="sp-sm-value">
                    {payrollClearanceData?.it_clearance?.other_recovery || "NA"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sp-subhead mt-4 mb-2">finance clearance summary</div>
          <div className="w-full">
            <div className="sp-sm">
              <div className="flex flex-wrap sp-sm-box">
                <div className="flex flex-col sp-emp-subbox">
                  <div className="sp-sm-label">
                    Is there any recovery on amount of Imprest?*
                  </div>
                  <div className="sp-sm-value">
                    {payrollClearanceData?.finance_clearance
                      ?.imprest_recovery || "NA"}
                  </div>
                </div>
                <div className="flex flex-col sp-emp-subbox">
                  <div className="sp-sm-label">Imprest Recovery Amount*</div>
                  <div className="sp-sm-value">
                    {payrollClearanceData?.finance_clearance
                      ?.imprest_recovery_amount || "NA"}
                  </div>
                </div>
                <div className="flex flex-col sp-emp-subbox1">
                  <div className="sp-sm-label">
                    Is there any recovery on account of Travel Advance?*
                  </div>
                  <div className="sp-sm-value">
                    {payrollClearanceData?.finance_clearance
                      ?.travel_advance_recovery || "NA"}
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap sp-sm-box">
                <div className="flex flex-col sp-emp-subbox">
                  <div className="sp-sm-label">
                    Travel Advance Recovery Amount*
                  </div>
                  <div className="sp-sm-value">
                    {payrollClearanceData?.finance_clearance
                      ?.travel_advance_recovery_amount || "NA"}
                  </div>
                </div>
                <div className="flex flex-col sp-emp-subbox1">
                  <div className="sp-sm-label">
                    Is there any other recovery?*
                  </div>
                  <div className="sp-sm-value">
                    {payrollClearanceData?.finance_clearance?.other_recovery ||
                      "NA"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sp-subhead mt-4 mb-2">admin clearance summary</div>
          <div className="w-full">
            <div className="sp-sm">
              <div className="flex flex-wrap sp-sm-box">
                <div className="flex flex-col sp-emp-subbox">
                  <div className="sp-sm-label">
                    Has the Access / Identity Card been recovered / destroyed by
                    the employee?*
                  </div>
                  <div className="sp-sm-value">
                    {payrollClearanceData?.admin_clearance
                      ?.access_card_recovered || "NA"}
                  </div>
                </div>
                <div className="flex flex-col sp-emp-subbox">
                  <div className="sp-sm-label">
                    Whether Employee has car under OYCS Scheme?*
                  </div>
                  <div className="sp-sm-value">
                    {payrollClearanceData?.admin_clearance
                      ?.car_in_oycs_scheme || "NA"}
                  </div>
                </div>
                <div className="flex flex-col sp-emp-subbox">
                  <div className="sp-sm-label">
                    Has the OYCS Scheme been closed by the employee?*
                  </div>
                  <div className="sp-sm-value">
                    {payrollClearanceData?.admin_clearance
                      ?.oycs_scheme_closed || "NA"}
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap sp-sm-box">
                <div className="flex flex-col sp-emp-subbox">
                  <div className="sp-sm-label">Other Recovery Amount</div>
                  <div className="sp-sm-value">
                    {payrollClearanceData?.admin_clearance?.other_recovery ||
                      "NA"}
                  </div>
                </div>
                <div className="flex flex-col sp-emp-subbox">
                  <div className="sp-sm-label">Recovery Amount</div>
                  <div className="sp-sm-value">
                    {payrollClearanceData?.admin_clearance
                      ?.total_recovery_amount || "NA"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {empData?.request_type === "Exit Interview Form" && (
        <div className="flex flex-col">
          <div
            className={`flex flex-col question-box-common align-items-flex-start w-fit-content ${
              exitInterviewQuestions?.satisfiedWithGrowth === "" &&
              isError &&
              "error-border"
            }`}
          >
            <div className="work-label">
              Were you satisfied with the growth opportunities within the role
              in the company?*
            </div>
            <div className="flex">
              <div
                className="flex items-center work-check-box"
                onClick={() =>
                  handleExitInterviewFields({
                    ...exitInterviewQuestions,
                    satisfiedWithGrowth: "Yes",
                  })
                }
              >
                <img
                  className="work-icon"
                  src={CheckIconGrey}
                  alt="work-icon"
                />
                <div className="work-check-label">Yes</div>
              </div>
              <div
                className="flex items-center work-check-box"
                onClick={() =>
                  handleExitInterviewFields({
                    ...exitInterviewQuestions,
                    satisfiedWithGrowth: "No",
                  })
                }
              >
                <img
                  className="work-icon"
                  src={CloseIconGrey}
                  alt="work-icon"
                />
                <div className="work-check-label">No</div>
              </div>
              <div
                className="flex items-center work-check-box"
                onClick={() =>
                  handleExitInterviewFields({
                    ...exitInterviewQuestions,
                    satisfiedWithGrowth: "Maybe",
                  })
                }
              >
                <img className="work-icon" src={MaybeIcon} alt="work-icon" />
                <div className="work-check-label">Maybe</div>
              </div>
            </div>
          </div>
          <div
            className={`flex flex-col question-box-common align-items-flex-start w-fit-content ${
              exitInterviewQuestions?.supportByManagerDuringStint === "" &&
              isError &&
              "error-border"
            }`}
          >
            <div className="work-label">
              Did your manager guide and support you well during your stint?*
            </div>
            <div className="flex">
              <div
                className="flex items-center work-check-box"
                onClick={() =>
                  handleExitInterviewFields({
                    ...exitInterviewQuestions,
                    supportByManagerDuringStint: "Yes",
                  })
                }
              >
                <img
                  className="work-icon"
                  src={CheckIconGrey}
                  alt="work-icon"
                />
                <div className="work-check-label">Yes</div>
              </div>
              <div
                className="flex items-center work-check-box"
                onClick={() =>
                  handleExitInterviewFields({
                    ...exitInterviewQuestions,
                    supportByManagerDuringStint: "No",
                  })
                }
              >
                <img
                  className="work-icon"
                  src={CloseIconGrey}
                  alt="work-icon"
                />
                <div className="work-check-label">No</div>
              </div>
              <div
                className="flex items-center work-check-box"
                onClick={() =>
                  handleExitInterviewFields({
                    ...exitInterviewQuestions,
                    supportByManagerDuringStint: "Maybe",
                  })
                }
              >
                <img className="work-icon" src={MaybeIcon} alt="work-icon" />
                <div className="work-check-label">Maybe</div>
              </div>
            </div>
          </div>
          <div className="flex flex-col question-box-common align-items-flex-start w-fit-content">
            <div className="work-label">
              Would you recommend this company to others?
            </div>
            <div className="flex">
              <div
                className="flex items-center work-check-box "
                onClick={() =>
                  handleExitInterviewFields({
                    ...exitInterviewQuestions,
                    recommendCompanyToOthers: "Yes",
                  })
                }
              >
                <img
                  className="work-icon"
                  src={CheckIconGrey}
                  alt="work-icon"
                />
                <div className="work-check-label">Yes</div>
              </div>
              <div
                className="flex items-center work-check-box"
                onClick={() =>
                  handleExitInterviewFields({
                    ...exitInterviewQuestions,
                    recommendCompanyToOthers: "No",
                  })
                }
              >
                <img
                  className="work-icon"
                  src={CloseIconGrey}
                  alt="work-icon"
                />
                <div className="work-check-label">No</div>
              </div>
              <div
                className="flex items-center work-check-box"
                onClick={() =>
                  handleExitInterviewFields({
                    ...exitInterviewQuestions,
                    recommendCompanyToOthers: "Maybe",
                  })
                }
              >
                <img className="work-icon" src={MaybeIcon} alt="work-icon" />
                <div className="work-check-label">Maybe</div>
              </div>
            </div>
          </div>
          <div className="flex">
            <div className="flex flex-col form-detail">
              <div className="emp-form-label">Name of your Next Employer</div>
              <input
                className="emp-form-input"
                onChange={(e) => {
                  handleExitInterviewFields({
                    ...exitInterviewQuestions,
                    nextEmployerName: e.target.value,
                  });
                }}
              />
            </div>
            <div className="flex flex-col form-detail">
              <div className="emp-form-label">
                Percentage Increase Offered by your Next Employer 30% - 45%
              </div>
              <input
                className="emp-form-input"
                onChange={(e) => {
                  handleExitInterviewFields({
                    ...exitInterviewQuestions,
                    percentageIncreaseNextEmployer: e.target.value,
                  });
                }}
              />
            </div>
          </div>
        </div>
      )}
      <div className="flex mt-auto w-full">
        <InitialsCircle fullName={fullName} size={24} type="Profile" />
        <input
          className="sp-input"
          placeholder="Mention a comment along with your approval"
          onChange={(e) => {
            setApproverRemarks(e.target.value);
          }}
        />
        {empData?.request_type === "Separation Approval" && (
          <div
            className="attachment-button"
            style={{
              backgroundColor: fileMandatoryErr && !empData?.file && "red",
            }}
            onClick={() => document.getElementById("fileInput").click()}
          >
            {separationQuestions?.file && (
              <div
                className="file-attachment"
                onClick={() => {
                  handleSeparationFields(
                    {
                      ...separationQuestions,
                      file: "",
                    },
                    "fileClear",
                  );
                  if (fileRef.current) {
                    fileRef.current.value = "";
                  }
                }}
              >
                <img src={Close} alt="" />
              </div>
            )}
            <img src={AttachmentIcon} alt="" />
            <input
              id="fileInput"
              style={{
                display: "none",
                opacity: 0,
                height: "0px",
                width: "0px",
              }}
              type="file"
              onChange={(e) => {
                handleSeparationFields(
                  {
                    ...separationQuestions,
                    file: e.target.files[0],
                  },
                  "file",
                );
              }}
              ref={fileRef}
            />

            <div className="attachment-button-text">
              {separationQuestions?.file?.name || "Attach Document"}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default SeperationApproval;
